export const PathNames = {
  HOME_PAGE: "/",
  ABOUT: "/about",
  PLANS: "/Plans",
  PRODUCTS: "/products",
};
